import React from 'react';
import NavbarLinks from "./NavBarLinks";
import { Navbar } from 'react-bootstrap';

const AppSidebar = ({ isMobile, isLoggedIn, activeMenuItem, handleMenuSelect }) => {
    const sidebarStyle = {
        width: 'max-content',
        height: 'calc(100vh)',
        backgroundColor: 'white',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        paddingTop: '1rem',
        
    };

    return (
        <>
            {isMobile ? (
                <>
                    {/*<Navbar.Toggle className='border-0 z-99' aria-controls="responsive-navbar-nav" />*/}
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <NavbarLinks activeMenuItem={activeMenuItem} handleMenuSelect={handleMenuSelect} isLoggedIn={isLoggedIn} />
                    </Navbar.Collapse>
                </>
            ) : (
                <div style={sidebarStyle}>
                    <NavbarLinks activeMenuItem={activeMenuItem} handleMenuSelect={handleMenuSelect} isLoggedIn={isLoggedIn} />
                </div>
            )}
        </>
    );
};

export default AppSidebar;
